import { AppBar, Box } from "@mui/material";
import React from "react";
import logo from "../../assets/images/main-logo.png";
import styles from "./HeaderOutside.module.scss"; // Adjust the path as necessary
import { Link } from "react-router-dom";
import { APP_MAINPAGE_URL } from "../../config/config";

const HeaderOutside: React.FC = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: "100%", // Adjust based on sidebar width

        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.05) !important;", // Remove default app bar shadow
        borderBottom: "1px solid var(--mui-palette-divider)", // Subtle border
        backgroundColor: "#fff", // Use Material-UI theme paper background
      }}
    >
      <Box className={styles.headerOutside}>
        <Link to={APP_MAINPAGE_URL}>
          <img
            src={logo}
            alt="Logo"
            className={styles.logo}
            style={{ height: "3rem", cursor: "pointer" }}
          />
        </Link>
      </Box>
    </AppBar>
  );
};

export default HeaderOutside;
